import Cookies from 'js-cookie';
import moment from 'moment';
import jwtDecode from 'jwt-decode';
import { select, put, delay } from 'redux-saga/effects';
import API from '@utils/api';
import AuthActions from './AuthRedux';
import CleansActions from './CleansRedux';
import logger from '@utils/logger';
import { AppConfig } from '@utils/config';
import { USER_ROLES } from '@services/minte';

const REFRESH_THRESHOLD = 300000;

export function* refreshAuthToken() {
  const state = yield select();
  const { auth } = state;

  if (!auth.token) {
    return;
  }
  logger.log('refreshing token');

  const { authToken, refreshToken } = auth.token;
  try {
    const { result: newAuthToken } = yield API.getAuthToken({
      authToken,
      refreshToken
    });
    yield put(
      AuthActions.setLoggedIn({
        authToken: newAuthToken,
        refreshToken
      })
    );
  } catch (err) {
    logger.log('refreshAuthToken Error', err);
    yield put(AuthActions.setLoggedOut());
  }
}

export function* loadUser() {
  // yield put(AppActions.setLoading(true));
  const { result: user } = yield API.getUserProfile();

  // yield put(AppActions.setLoading(false));

  if (user && user.role !== USER_ROLES.PROPERTY_MANAGER) {
    try {
      const { result: propertySetting } = yield API.getPropertySettingStatus();
      yield put(AuthActions.setUserSettings(propertySetting));
    } catch (err) {
      logger.log('error on getting property setting');
    }
  }
  yield put(AuthActions.setUser(user));
}

export function* storeToken(action) {
  const { token } = action;
  const { authToken, refreshToken } = token;
  Cookies.set('authToken', authToken, { domain: AppConfig.DOMAIN });
  Cookies.set('refreshToken', refreshToken, { domain: AppConfig.DOMAIN });

  try {
    const decoded = jwtDecode(authToken);
    const { expiry } = decoded;

    const diff = moment(expiry).diff(moment());
    const threshHold = Math.max(diff - REFRESH_THRESHOLD, 0);

    API.setAuthHeader(authToken);
    yield delay(threshHold);
    yield put(AuthActions.setRefreshAuthRequest());
  } catch (er) {
    logger.log('error on decoding auth token');
  }

  yield true;
}

export function* storeUser(action) {
  const { user } = action;

  try {
    const { properties } = user;
    if (Array.isArray(properties) && properties.length === 1) {
      yield put(CleansActions.setMyCleansHomeViewProperty(properties[0]));
    }
  } catch (err) {
    //Nothing to do
  }
  yield true;
}

export function* clearToken() {
  API.setAuthHeader(null);
  Cookies.remove('authToken', { domain: AppConfig.DOMAIN });
  Cookies.remove('refreshToken', { domain: AppConfig.DOMAIN });
  yield true;
}
